interface HomeHighlightsListProps {
  highlights: any[] | undefined;
  onHighlightClick: (highlight: any) => void;
}

const HomeHighlightsList = ({ highlights, onHighlightClick }: HomeHighlightsListProps) => {
  return (
    <ul className="preflight preflight-ul grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 md:gap-3">
      {highlights?.map((highlight: any) => (
        <li key={highlight._id}>
          <button
            type="button"
            disabled={highlight.disabled}
            className="preflight preflight-button transition-opacity hover:opacity-80 disabled:opacity-50"
            onClick={() => onHighlightClick(highlight)}
          >
            <img
              className="preflight preflight-img aspect-video rounded md:rounded-lg"
              src={highlight.thumbnailURL}
              alt={highlight.title}
              loading="lazy"
            />
          </button>
        </li>
      ))}
    </ul>
  );
};

export default HomeHighlightsList;
